import { render } from "./AccountQrcodeVerification.vue?vue&type=template&id=df631ce6&scoped=true&ts=true"
import script from "./AccountQrcodeVerification.vue?vue&type=script&lang=ts"
export * from "./AccountQrcodeVerification.vue?vue&type=script&lang=ts"

import "./AccountQrcodeVerification.vue?vue&type=style&index=0&id=df631ce6&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df631ce6"]])